<div id="loader" class="rc-loader" [class.transparent]="transparent" [class.withinContent]="withinContent">
  <rc-loader variant="primary" [size]="isStandalone && size === 'large' ? 'medium' : size"></rc-loader>
</div>
